const productTargetSelectors = [
  '#MainContent .product-information',
  '#product-information.product-information',
  '[id^="ProductInformation-"]',
];

const findProductTarget = () => {
  for (const selector of productTargetSelectors) {
    const target = document.querySelector(selector);
    if (target) return target;
  }

  return null;
};

for (const story of document.querySelectorAll('[data-seal-fermentation-story]')) {
  story.addEventListener('click', (event) => {
    const purchaseLink = event.target.closest('[data-seal-fermentation-purchase]');
    if (!purchaseLink) return;

    const productTarget = findProductTarget();
    if (!productTarget) return;

    event.preventDefault();
    productTarget.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
  });
}
